import { render, staticRenderFns } from "./ViewCalendarHeader.vue?vue&type=template&id=08ad3834&scoped=true"
import script from "./ViewCalendarHeader.vue?vue&type=script&lang=js"
export * from "./ViewCalendarHeader.vue?vue&type=script&lang=js"
import style0 from "./ViewCalendarHeader.vue?vue&type=style&index=0&id=08ad3834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ad3834",
  null
  
)

export default component.exports